import type { SvgPathProps } from '../Icon';

import { getIcon } from '../Icon/utils';

const Edit: React.FC<SvgPathProps> = ({ size, isHovered }: SvgPathProps): React.ReactElement => {
  const normal = (
    <>
      <path d="M23.747 10.244a.75.75 0 0 1 0 1.5h-8.579a5.418 5.418 0 0 0-5.418 5.418V30.8a5.418 5.418 0 0 0 5.418 5.418h13.638a5.418 5.418 0 0 0 5.418-5.418v-8.58a.75.75 0 0 1 1.5 0v8.58a6.918 6.918 0 0 1-6.918 6.918H15.168A6.918 6.918 0 0 1 8.25 30.8V17.162a6.918 6.918 0 0 1 6.918-6.918h8.58Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.083 7.579a4.5 4.5 0 0 1 6.315-.008l.163.168a4.503 4.503 0 0 1-.14 6.241h-.001L26.019 26.333a.752.752 0 0 1-.317.187L18.1 28.765a.75.75 0 0 1-.962-.72v-.006c0-.072.01-.144.031-.213l2.242-7.566.033-.09a.75.75 0 0 1 .159-.23l12.48-12.36.001-.001ZM18.995 26.935l5.223-1.54-3.677-3.677-1.546 5.217Zm1.955-6.222 4.284 4.284 10.13-10.09-4.255-4.255-10.159 10.06ZM37.348 8.64a3 3 0 0 0-4.211.005L31.82 9.95l4.252 4.252 1.29-1.284a3.002 3.002 0 0 0-.013-4.275h-.001Z"
      />
    </>
  );

  const normalHover = (
    <>
      <path d="M23.747 10.244a.75.75 0 0 1 0 1.5h-8.579a5.418 5.418 0 0 0-5.418 5.418V30.8a5.418 5.418 0 0 0 5.418 5.418h13.638a5.418 5.418 0 0 0 5.418-5.418v-8.58a.75.75 0 0 1 1.5 0v8.58a6.918 6.918 0 0 1-6.918 6.918H15.168A6.918 6.918 0 0 1 8.25 30.8V17.162a6.918 6.918 0 0 1 6.918-6.918h8.58Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.083 9.579a4.5 4.5 0 0 1 6.315-.008l.163.168a4.503 4.503 0 0 1-.14 6.241h-.001L24.019 28.333a.752.752 0 0 1-.317.187L16.1 30.765a.75.75 0 0 1-.962-.72v-.006c0-.072.01-.144.031-.213l2.242-7.566.033-.09a.75.75 0 0 1 .159-.23l12.48-12.36.001-.001ZM16.995 28.935l5.223-1.54-3.677-3.677-1.546 5.217Zm1.955-6.222 4.284 4.284 10.13-10.09-4.255-4.255-10.159 10.06ZM35.348 10.64a3 3 0 0 0-4.211.005L29.82 11.95l4.252 4.252 1.29-1.284a3.002 3.002 0 0 0-.013-4.274l-.001-.002Z"
      />
    </>
  );

  return getIcon({ size, isHovered, normal, normalHover });
};

export default Edit;
